import { regex } from './regex.validator';

export function httpUrl(allowEmpty = true) {
    return regex(/^(https?):\/\/([\w+?\.\w+])+([a-zA-Z0-9\~\!\@\#\$\%\^\&\*\(\)_\-\=\+\\\/\?\.\:\;\'\,]*)?$/, allowEmpty);
}
